export type Testimonial = {
  headline: string
  quote: string[]
  author: string
  location: string
  role: string
  avatar?: string
}

export const testimonials: Testimonial[] = [
  {
    headline: 'I Used to Spend Half My Week Figuring Out Practice.',
    quote: [
      'I knew football. What I struggled with was turning that knowledge into an actual practice plan. I would show up with a few drills and figure out the rest as we went.',
      "Now I can look at the Practice Card, know exactly what we're doing next, and keep the kids moving.",
    ],
    author: 'James C.',
    location: 'Portland, OR',
    role: 'Volunteer Youth Flag Football Coach',
  },
  {
    headline: 'The Difference Was Obvious at Practice.',
    quote: [
      'Before, there was always a group waiting for instructions while I figured out what to do next.',
      'With the four-quarter structure, everyone knew where we were in practice and what came next. We spent less time standing around and more time actually practicing.',
    ],
    author: 'Michael S.',
    location: 'Austin, TX',
    role: '5v5 Flag Football Coach',
  },
  {
    headline: 'Built for the Reality of Youth Football Coaching',
    quote: [
      'You don’t need a complicated coaching system. You need a practice structure you can actually use when you have limited time, limited help, and a group of kids ready to move.',
    ],
    author: 'Daniel P.',
    location: 'San Diego, CA',
    role: 'Youth Football Coaching System',
  },
  {
    headline: 'Practice Takes an Hour. Planning It Shouldn’t Take Another.',
    quote: [
      'I used to spend almost as much time planning practice as I did running it. Now I can grab the Practice Card, review the plan, and walk onto the field ready to go.',
      'It took a lot of the mental work out of practice planning.',
    ],
    author: 'Robert R.',
    location: 'Phoenix, AZ',
    role: 'First-Time Parent Coach',
  },
  {
    headline: 'It Fits the Way We Already Coach.',
    quote: [
      'I didn’t need to completely change our program. The structure gave us a consistent way to organize practice, while the actual activities could change based on what our team needed.',
    ],
    author: 'David B.',
    location: 'Miami, FL',
    role: 'Youth Tackle Football Coach',
  },
]
